import { useEventsReportQuery, useFinancialReportQuery, useGiftsReportQuery, useRosterFilesReportQuery, useShipmentsReportQuery } from '../../generated/graphql';

export const useFinancialReport = (month: string, companyId?: string) => {
  const query = useFinancialReportQuery({ variables: { month, companyId } });
  return { data: query.data?.financialReport || [], error: query.error, loading: query.loading };
};

export const useEventReport = (month: string, companyId?: string) => {
  const query = useEventsReportQuery({ variables: { month, companyId } });
  return { data: query.data?.eventsReport || [], error: query.error, loading: query.loading };
};

export const useGiftReport = (month: string, companyId?: string) => {
  const query = useGiftsReportQuery({ variables: { month, companyId } });
  return { data: query.data?.giftsReport || [], error: query.error, loading: query.loading };
};

export const useShipmentReport = (month: string, companyId?: string) => {
  const query = useShipmentsReportQuery({ variables: { month, companyId } });
  return { data: query.data?.shipmentsReport || [], error: query.error, loading: query.loading };
};

export const useRosterFilesReport = (month: string, companyId?: string) => {
  const query = useRosterFilesReportQuery({ variables: { month, companyId } });
  return { data: query.data?.rosterFilesReport || [], error: query.error, loading: query.loading };
};
